import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles'
import { validateInput } from '../../../../../../utils/input-validation'
import { mobile_info_details } from 'data/standard-reportV2_2/mobile-info'

const useStyles = makeStyles(theme => ({
	customTooltip: {
		fontSize: '14px',
		maxWidth: '500px',
		whiteSpace: 'pre-line',
		textAlign: 'center',
	},
}))

export default function SubLabelType2({
	type,
	flags,
	item,
	onFillForm,
	answers,
	validationRules = {}
}) {
	const classes = useStyles()
	const answer = answers.find(ans => ans.DataSetItemID === item.id)
	const is2G = item.label.includes('2G') && flags['2G'] === false
	const is5G = item.label.includes('5G')
	const is5GArea = item.label.includes('5G (พื้นที่)')
	const isFiveInput = item.label.includes('-ภาค')
	const excelValueCol = mobile_info_details.find(
		({ id }) => id === item.id
	)?.excelValueCol ?? []

	// const is2G = item.label.includes('2G') ? true : false
	// console.log("excelValueCol", excelValueCol)

	const columns = [
		{ key: 'D', field: 'DataValueMonth1' },
		{ key: 'E', field: 'DataValueMonth2' },
		{ key: 'F', field: 'DataValueMonth3' },
		{ key: 'G', field: 'DataValueMonthAvg' }
	];

	const renderInput = (itemId, fieldName, value, className = '', disabled = false) => {
		if (disabled) {
			return (
				<Input
					className={className}
					value={null}
					disabled
					readOnly
				/>
			)
		}

		// Override validation rules for Average column to allow float values
		let currentRules = validationRules
		if (fieldName === 'DataValueMonthAvg') {
			currentRules = { ...validationRules, dataType: 'float' }
		} else if (fieldName === 'DataValueExtra') {
			currentRules = { ...validationRules, dataType: 'text', maxLength: 250 }
		}

		const { isValid, message, status } = validateInput(value, currentRules)

		// Merge className with error/warning styling
		let statusClass = ''
		if (value && status === 'error') statusClass = 'bg-red-200 border-2 border-red-500'
		else if (value && status === 'warning') statusClass = 'bg-yellow-100 border-2 border-yellow-500'

		const finalClassName = `${className} ${statusClass}`

		// START OF EDITS
		const handleBlur = (e) => {
			let val = e.target.value
			if (val.startsWith('.')) {
				val = '0' + val
			}

			// Use currentRules instead of validationRules to check dataType
			if (currentRules.dataType === 'float' && val !== '' && !isNaN(val)) {
				const parts = val.toString().split('.')
				const decimalLen = parts[1] ? parts[1].length : 0

				if (decimalLen < 2) {
					const formatted = parseFloat(val).toFixed(2)
					if (formatted !== e.target.value) {
						onFillForm(type, itemId, fieldName, formatted)
					}
				} else if (val !== e.target.value) {
					onFillForm(type, itemId, fieldName, val)
				}
			}
		}
		// END OF EDITS

		// Determine tooltip content: use 'value' for DataValueExtra (to show full text), otherwise use 'message' (for validation errors)
		const tooltipTitle = fieldName === 'DataValueExtra' ? value : message
		// For DataValueExtra, we want standard hover behavior (uncontrolled), so open should be undefined.
		// For others, keep existing behavior (controlled by error presence), assuming original intent was to only show tooltip on error.
		const shouldOpenTooltip = fieldName === 'DataValueExtra' ? undefined : (!!message && !!value)

		return (
			<Tooltip classes={{ tooltip: classes.customTooltip }} title={tooltipTitle || ''} arrow open={shouldOpenTooltip} placement="top">
				<Input
					className={finalClassName}
					value={value}
					onChange={e =>
						onFillForm(type, itemId, fieldName, e.target.value)
					}
					onBlur={handleBlur}
					type="text"
					error={status === 'error' && !!value}
				/>
			</Tooltip>
		)
	}

	return (
		<>
			{isFiveInput ? (
				<Grid className="col-span-12 text-center border flex flex-row justify-around">
					<Grid className="border-r w-2/12 p-1 font-bold text-left">
						{item.label}
					</Grid>
					{renderInput(item.id, 'DataValueExtra', answer?.DataValueExtra, `border-r border-gray-500 w-2/12 p-1 font-bold text-center bg-yellow_input_bg`)}
					{renderInput(item.id, 'DataValueMonth1', answer?.DataValueMonth1, `border-r border-gray-500 w-2/12 p-1 font-bold text-center bg-green_input_bg`)}
					{renderInput(item.id, 'DataValueMonth2', answer?.DataValueMonth2, `border-r border-gray-500 w-2/12 p-1 font-bold text-center bg-green_input_bg`)}
					{renderInput(item.id, 'DataValueMonth3', answer?.DataValueMonth3, `border-r border-gray-500 w-2/12 p-1 font-bold text-center bg-green_input_bg`)}
					{renderInput(item.id, 'DataValueMonthAvg', answer?.DataValueMonthAvg, `border-r border-gray-500 w-2/12 p-1 font-bold text-center bg-green_input_bg`)}
				</Grid>
			) : (
				excelValueCol.length > 0 ? (
					<Grid className="col-span-12 text-center border flex flex-row justify-around">
						{/* Label Column */}
						<Grid className="border-r w-4/12 p-1 font-bold text-left">
							{item.label}
						</Grid>

						{/* Data Columns */}
						{columns.map(({ key, field }) => (
							<Grid key={key} className="border-r border-gray-500 w-2/12 p-1 font-bold text-center">
								{excelValueCol.includes(key) ? (
									renderInput(item.id, field, answer?.[field], "w-full bg-green_input_bg")
								) : (
									renderInput(item.id, field, null, "w-full", true)
								)}
							</Grid>
						))}
					</Grid>
				) : !is2G ? (
					<Grid className="col-span-12 text-center border flex flex-row justify-around">
						{/* Label Column */}
						<Grid className="border-r w-4/12 p-1 font-bold text-left">
							{item.label}
						</Grid>

						{/* Data Columns */}
						{columns.slice(0, 2).map(({ field }) => (
							<Grid key={field} className={`border-r border-gray-500 w-2/12 p-1 font-bold text-center`}>
								{renderInput(item.id, field, answer?.[field], `w-full ${is5GArea ? "bg-yellow_input_bg" : "bg-green_input_bg"}`)}
							</Grid>
						))}
						{!is5G && columns.slice(2).map(({ field }) => (
							<Grid key={field} className="border-r border-gray-500 w-2/12 p-1 font-bold text-center">
								{renderInput(item.id, field, answer?.[field], "w-full bg-green_input_bg")}
							</Grid>
						))}
					</Grid>
				) : null
			)}
		</>
	)
}
